import { render, staticRenderFns } from "./CollaboratorInvitationForm.vue?vue&type=template&id=18925ab5&"
import script from "./CollaboratorInvitationForm.vue?vue&type=script&lang=js&"
export * from "./CollaboratorInvitationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports